import Bugsnag from 'utils/bugsnag'
import ApiClient from 'api-client/ApiClient'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import { flatten } from 'ramda'
import { someAsync } from 'utils/async'
import { trackEvent } from 'utils/tracking'
import ActionsSet from 'core/actions/ActionsSet'
import DeleteAction from 'core/actions/DeleteAction'
import ListAction from 'core/actions/ListAction'
import parseClusterIdsFromParams from 'app/plugins/infrastructure/components/combinedClusters/parseClusterIdsFromParams'

const { qbert } = ApiClient.getInstance()

export const csiDriverActions = ActionsSet.make<DataKeys.CSIDrivers>({
  uniqueIdentifier: 'id',
  indexBy: 'clusterId',
  entityName: entityNamesByKey[DataKeys.CSIDrivers],
  cacheKey: DataKeys.CSIDrivers,
})

export const listCSIDrivers = csiDriverActions.add(
  new ListAction<DataKeys.CSIDrivers, { clusterId: string }>(async (params) => {
    Bugsnag.leaveBreadcrumb('Attempting to get CSI Drivers', params)
    return qbert.getCSIDrivers(params.clusterId)
  }),
)

listCSIDrivers.addDependency(DataKeys.PersistentVolumes)
listCSIDrivers.addDependency(DataKeys.PersistentVolumeClaims)

export const deleteCSIDrivers = csiDriverActions.add(
  new DeleteAction<DataKeys.CSIDrivers, { clusterId: string; name: string; id: string }>(
    async ({ clusterId, name, id }) => {
      Bugsnag.leaveBreadcrumb('Attempting to delete CSI driver', { id, clusterId, name })
      await qbert.deleteCSIDriver(clusterId, name)
      trackEvent('Delete CSI Driver', { clusterId, name, id })
    },
  ),
)
